import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addClientsToField, removeClientsFromField } from '../../api/CHAMPS/champs';

export const useAddClientsToField = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, clientIds }) => addClientsToField(id, clientIds),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['champ', String(variables.id)] });
    },
  });
};

export const useRemoveClientsFromField = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, clientIds }) => removeClientsFromField(id, clientIds),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['champ', String(variables.id)] });
    },
  });
};
